<div class="d-flex align-items-center justify-content-between mb-5">
  <h1 class="montserrat-light text-gray-500 text-capitalize">Contact Us</h1>
</div>
<div>
  <h4>Here’s some ways to get in touch</h4>
  <div class="mt-5">
    <h5>Call us</h5>
    <br />
    <div class="item">
      <span>In the UAE: </span>
      <span
        ><b><a href="tel:155">155</a></b> or
        <b><a href="tel:800155">800 155</a></b></span
      >
    </div>
    <div class="item">
      <span>Overseas: </span>
      <span
        ><b><a href="tel:+971555678155">+971 5 55678155</a></b></span
      ><span> </span>
    </div>
    <hr class="height-60" />
    <br />
    <h5>Email</h5>
    <br />
    <div class="item">
      <span
        ><a href="mailto:info@themediaconnector.com"
          >info@themediaconnector.com</a
        ></span
      >
    </div>
    <br />
    <hr class="height-60" />
    <br />
    <h5>Terms &amp; Conditions</h5>
    <br />
    <div class="item">
      <span
        ><a [routerLink]="['/terms-and-conditions']"
          >Check out our terms and conditions</a
        ></span
      >
    </div>
    <div class="item">
      <span
        ><a [routerLink]="['/privacy-policy']">Check out our Privacy Policy</a></span
      >
    </div>
  </div>
</div>
